import React from "react";
import {
  Drawer,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Tooltip
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import SettingsIcon from "@mui/icons-material/Settings";
import GroupIcon from "@mui/icons-material/Group";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"; // Added for Orders

import { Link as RouterLink } from "react-router-dom";

export default function AdminDashboardDrawer({ open, onToggle }) {
  const drawerWidth = open ? 250 : 100;

  const menuItems = [
    { label: "DASHBOARD", icon: <DashboardIcon />, path: "/admin/dashboard" },
    { label: "REGISTERED USERS", icon: <GroupIcon />, path: "/admin/registered-users" },
    { label: "PROFILES", icon: <AccountCircleIcon />, path: "/admin/profiles" },
    { label: "DOMAIN CONTROLS", icon: <SettingsIcon />, path: "/admin/blocked-domains" },

    // { label: "REPORTS", icon: <InsertDriveFileIcon />, path: "/admin/reports" },
    // { label: "ORDERS", icon: <ShoppingCartIcon />, path: "/admin/orders" },
    // { label: "UPLOAD PROFILES", icon: <CloudUploadIcon />, path: "/admin/upload" },
    { label: "SEARCH REQUESTS", icon: <SearchIcon />, path: "/admin/search" },
    // { label: "ADMINS", icon: <PeopleIcon />, path: "/admin/admins" },
    // { label: "SETTINGS", icon: <SettingsIcon />, path: "/admin/settings" }
  ];

  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          transition: "width 0.2s ease",
          bgcolor: "#000", // Black background
          color: "#fff",
          borderRight: "1px solid #2e2e2e",
          height: "100vh",
          boxSizing: "border-box",
          position: "fixed",
          zIndex: 1200
        }
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {/* Brand Title */}
        <Box
          sx={{
            px: open ? 2 : 0,
            py: 2,
            display: "flex",
            justifyContent: open ? "flex-start" : "center",
            alignItems: "center",
            bgcolor: "#000"
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: open ? 20 : 0,
              color: "#fff",
              transition: "0.2s"
            }}
          >
            list{`{a}`}
          </Typography>
        </Box>

        <Divider sx={{ borderColor: "#2e2e2e" }} />

        {/* Toggle Button */}
        <IconButton
          onClick={onToggle}
          sx={{
            color: "#fff",
            alignSelf: open ? "flex-end" : "center",
            m: 1
          }}
        >
          <MenuIcon />
        </IconButton>

        <List sx={{ flexGrow: 1 }}>
          {menuItems.map(({ label, icon, path }) => (
            <Tooltip key={label} title={open ? "" : label} placement="right">
              <ListItem
                button
                component={RouterLink}
                to={path}
                sx={{
                  py: 1.5,
                  px: open ? 2 : 1,
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#1c1c1c"
                  }
                }}
              >
                <ListItemIcon sx={{ color: "#fff", minWidth: open ? 40 : 0 }}>
                  {icon}
                </ListItemIcon>
                {open && (
                  <ListItemText
                    primary={label}
                    primaryTypographyProps={{
                      fontWeight: "bold",
                      fontSize: 13,
                      letterSpacing: 1.2
                    }}
                  />
                )}
              </ListItem>
            </Tooltip>
          ))}
        </List>
      </Box>
    </Drawer>
  );
}